<template>
  <div class="cta">
    <vb-button
      class="cta__btn"
      :class="!cta_disabled ? 'cta__btn--hidden' : ''"
      :vb_options="{
        text: 'Continua',
        variant: 'info',
        icon_disabled: 'lock_v2',
        disabled: cta_disabled
      }"
      @click="scroll_to_bottom()"
    />
    <div v-if="cta_disabled" :class="'cta__text text-' + cta_status.variant" >
      <vb-icon class="cta__text-icon mr-1" :name="'info'" :color="sass(cta_status.variant)" :size="14" />
      <p class="mb-0" v-html="cta_status.label" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'resume-cta',

  inject: ['cta_status_checker', 'get_scroll_target'],

  components: {
  },

  props: {
    property_data: Object
  },

  data() {
    return {
    }
  },

  computed: {

    // Gestisce i copy e lo stato della cta
    cta_status(){

      let label = `Scegli una camera <span class="d-block mt-1 ml-n3 text--sm">Seleziona l'opzione più adatta alle tue esigenze.</span>`,
          variant = 'dark'

      const disabled = Object.keys(this.property_data).length === 0 ||
                       !this.get_availability(this.property_data.live_price).can_go_to_checkout

      const result = {  // ci torna utile per implementazione multicamera
        disabled: this.property_data.amount_points ? false : disabled,
        label,
        variant
      }
      this.cta_status_checker(result)
      return result
    },

    // Separa la logica del disabled per poterla riutilizzare e semplificare il template.
    cta_disabled() {
      return this.cta_status.disabled
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {

    scroll_to_bottom() {
      const target = this.get_scroll_target()
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }

  },
}
</script>

<style lang="scss" scoped>

  .cta {
    display: flex;
    align-items: center;
    flex-direction: column;

    @include media-breakpoint-up(xl){
      display: block
    }

    &__btn {
      line-height: normal;

      &--hidden{
        @include media-breakpoint-down(md){
          display: none;
        }
      }
    }

    &__text {
      margin-bottom: 0;
      margin-top: $grid-gutter-width;
      line-height: 18px;
      text-align: center;

      @include media-breakpoint-up(xl){
        display: flex;
        align-items: flex-start;
        text-align: left;
      }

      &-icon {
        display: none;

        @include media-breakpoint-up(xl){
          margin-top: 2px;
          display: block;
        }
      }
    }
  }

</style>